import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_videogist-3/artifacts/809w15is_summbee%20logo_just%20bee.png";

function WelcomeModal({ onComplete }) {
  const [marketingConsent, setMarketingConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await onComplete(marketingConsent);
  };

  return (
    <div className="modal-overlay" data-testid="welcome-modal">
      <div className="modal-content welcome-modal">
        <div className="modal-header">
          <div className="welcome-logo-section">
            <img src={LOGO_URL} alt="SummBee" className="welcome-logo" />
            <h2>Welcome to SummBee</h2>
          </div>
        </div>
        
        <div className="modal-body">
          <p className="welcome-message">
            We're excited to help you transform video content into structured intelligence.
          </p>
          
          <div className="trial-info">
            <div className="trial-badge">FREE TRIAL</div>
            <p>You've been granted <strong>5 Pro-tier extractions</strong> to experience our full capabilities.</p>
          </div>
          
          <div className="consent-section">
            <div className="consent-item">
              <Checkbox 
                id="marketing-consent"
                data-testid="marketing-consent-checkbox"
                checked={marketingConsent}
                onCheckedChange={setMarketingConsent}
              />
              <Label htmlFor="marketing-consent" className="consent-label">
                Keep me updated with product news, feature releases, and efficiency tips
              </Label>
            </div>
            <p className="consent-note">
              We respect your inbox. Unsubscribe anytime. View our privacy policy.
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <Button 
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="continue-button"
            data-testid="complete-onboarding-button"
          >
            {isSubmitting ? "Setting up..." : "Start Extracting"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeModal;
